(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Remove "Sign in with Shop" elements
  function removeShopPayElements() {
    const shopPaySelectors = [
      '[data-testid="authorize-modal"]',
      '.shop-pay-btn',
      '.shop-pay-button', 
      '[class*="shop-pay"]',
      '[class*="ShopPay"]',
      'button[aria-label*="Shop"]',
      'button[aria-label*="shop"]',
      '.btn--shop-pay',
      '.shopify-cleanslate',
      'iframe[src*="shop.app"]',
      '[data-shop-pay]',
      '[data-shopid-button]',
      '[data-shop-id]'
    ];
    
    shopPaySelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.remove();
      });
    });
  }
  
  // Remove immediately and after page loads
  removeShopPayElements();
  setTimeout(removeShopPayElements, 1000);
  setTimeout(removeShopPayElements, 3000);
  
  const retailRadio = document.getElementById('type-retail');
  const businessRadio = document.getElementById('type-business');
  const businessFields = document.getElementById('business-fields');
  const businessDataField = document.getElementById('business-data');
  
  // Simple toggle function
  function toggleBusinessFields() {
    if (businessRadio.checked) {
      businessFields.style.display = 'block';
      businessFields.classList.add('show');
    } else {
      businessFields.style.display = 'none';
      businessFields.classList.remove('show');
    }
    updateBusinessNote();
  }
  
  // Update business note in real-time
  function updateBusinessNote() {
    // Get all contact information fields
    const phone = document.getElementById('RegisterForm-phone').value || '';
    const address = document.getElementById('RegisterForm-Address1').value || '';
    const postalCode = document.getElementById('RegisterForm-Zip').value || '';
    const city = document.getElementById('RegisterForm-City').value || '';
    const province = document.getElementById('RegisterForm-Province').value || '';
    const country = document.getElementById('RegisterForm-Country').value || '';
    const companyName = document.getElementById('company-name').value || '';
    
    if (businessRadio.checked) {
      // Business customer note
      const businessPhone = document.getElementById('business-phone').value || '';
      const businessReg = document.getElementById('business-registration').value || '';
      const pdfDataTemp = document.getElementById('pdf-data-temp').value || '';
      
      let businessNote = 'Customer Type: Business';
      
      // Contact Information
      if (phone.trim()) businessNote += ' | Phone: ' + phone.trim();
      if (address.trim()) businessNote += ' | Address: ' + address.trim();
      if (city.trim()) businessNote += ' | City: ' + city.trim();
      if (postalCode.trim()) businessNote += ' | Postal Code: ' + postalCode.trim();
      if (province.trim()) businessNote += ' | Province: ' + province.trim();
      if (country.trim()) businessNote += ' | Country: ' + country.trim();
      
      // Business-specific fields
      if (companyName.trim()) businessNote += ' | Company: ' + companyName.trim();
      if (businessPhone.trim()) businessNote += ' | Business Phone: ' + businessPhone.trim();
      if (businessReg.trim()) businessNote += ' | Registration: ' + businessReg.trim();
      
      // Add PDF info if uploaded
      if (pdfDataTemp) {
        try {
          const pdfInfo = JSON.parse(pdfDataTemp);
          const fileSizeKB = Math.round(pdfInfo.fileSize / 1024);
          businessNote += ` | Document: ${pdfInfo.fileName} (${fileSizeKB}KB)`;
        } catch (e) {
          businessNote += ' | Document: Uploaded';
        }
      }
      
      businessDataField.value = businessNote;
    } else {
      // Retail customer note
      let retailNote = 'Customer Type: Retail';
      
      // Add contact information for retail customers too
      if (phone.trim()) retailNote += ' | Phone: ' + phone.trim();
      if (address.trim()) retailNote += ' | Address: ' + address.trim();
      if (city.trim()) retailNote += ' | City: ' + city.trim();
      if (postalCode.trim()) retailNote += ' | Postal Code: ' + postalCode.trim();
      if (province.trim()) retailNote += ' | Province: ' + province.trim();
      if (country.trim()) retailNote += ' | Country: ' + country.trim();
      
      businessDataField.value = retailNote;
      
      // Clear PDF data for retail customers
      const pdfDataField = document.getElementById('pdf-tags-field');
      if (pdfDataField) pdfDataField.value = '';
    }
  }
  
  // Make radio button divs clickable
  document.querySelectorAll('.field-radio').forEach(function(radioDiv, index) {
    radioDiv.addEventListener('click', function() {
      if (index === 0) {
        retailRadio.checked = true;
        businessRadio.checked = false;
      } else {
        retailRadio.checked = false;
        businessRadio.checked = true;
      }
      toggleBusinessFields();
    });
  });
  
  // Also handle direct radio button clicks
  retailRadio.addEventListener('click', function() {
    businessRadio.checked = false;
    toggleBusinessFields();
  });
  
  businessRadio.addEventListener('click', function() {
    retailRadio.checked = false;
    toggleBusinessFields();
  });
  
  // Event listeners for business fields - update note as user types  
  setTimeout(function() {
    const companyField = document.getElementById('company-name');
    const phoneField = document.getElementById('business-phone'); 
    const regField = document.getElementById('business-registration');
    
    if (companyField) companyField.addEventListener('input', updateBusinessNote);
    if (phoneField) phoneField.addEventListener('input', updateBusinessNote);
    if (regField) regField.addEventListener('input', updateBusinessNote);
  }, 100);
  
  // PDF upload elements
  const uploadArea = document.getElementById('upload-area');
  const fileInput = document.getElementById('pdf-upload');
  const filePreview = document.getElementById('file-preview');
  const fileName = document.getElementById('file-name');
  const removeButton = document.getElementById('remove-file');
  const uploadStatus = document.getElementById('upload-status');
  const pdfDataTemp = document.getElementById('pdf-data-temp');
  const pdfDataField = document.getElementById('pdf-tags-field');
  
  uploadArea.addEventListener('click', () => fileInput.click());
  
  // S3 Upload Function
  async function uploadToS3(file, customerEmail) {
    const s3Key = `${customerEmail}-business-registration.pdf`;
    const uploadUrl = `https://balto-bites-shopify-bucket.s3.us-east-2.amazonaws.com/${s3Key}`;
    
    // Just a simple fetch - no auth headers, no AWS keys, nothing!
    const response = await fetch(uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/pdf' },
      body: file
    });
    
    return { key: s3Key, url: uploadUrl };
  }

  fileInput.addEventListener('change', function(e) {
    const file = e.target.files[0];
    if (file) {
      if (file.type === 'application/pdf' && file.size <= 2 * 1024 * 1024) {
        fileName.textContent = file.name;
        filePreview.classList.add('show');
        
        uploadStatus.className = 'upload-status';
        uploadStatus.textContent = 'Uploading document to secure storage...';
        
        // Get customer email for filename
        const customerEmail = document.getElementById('RegisterForm-email').value;
        
        if (!customerEmail) {
          uploadStatus.className = 'upload-status error';
          uploadStatus.textContent = 'Please enter your email address first';
          return;
        }
        
        // Upload directly to S3
        uploadToS3(file, customerEmail)
          .then(result => {
            const fileInfo = {
              fileName: file.name,
              originalName: file.name,
              s3Key: result.key,
              s3Url: result.url,
              fileSize: file.size,
              uploadDate: new Date().toISOString(),
              uploaded: true
            };
            
            // Store upload info (no PDF data, just metadata)
            pdfDataTemp.value = JSON.stringify(fileInfo);
            
            uploadStatus.className = 'upload-status success';
            uploadStatus.textContent = 'Document uploaded successfully to secure storage';
            updateBusinessNote();
          })
          .catch(error => {
            console.error('S3 Upload error:', error);
            uploadStatus.className = 'upload-status error';
            uploadStatus.textContent = 'Upload failed. Please try again.';
          });
      } else {
        uploadStatus.className = 'upload-status error';
        uploadStatus.textContent = 'Please select a PDF file under 2MB';
      }
    }
  });
  
  removeButton.addEventListener('click', function() {
    fileInput.value = '';
    filePreview.classList.remove('show');
    pdfDataTemp.value = '';
    pdfDataField.value = '';
    uploadStatus.className = 'upload-status';
    uploadStatus.textContent = '';
    updateBusinessNote();
  });
  
  // Initialize
  toggleBusinessFields();
  
  // Debug form submission to check phone field
  const form = document.querySelector('form');
  form.addEventListener('submit', function(e) {
    const phoneValue = document.getElementById('RegisterForm-Phone').value;
    const cityValue = document.getElementById('RegisterForm-City').value;
    console.log('Form submission debug:');
    console.log('Phone value:', phoneValue);
    console.log('City value:', cityValue);
    console.log('Phone field name:', document.getElementById('RegisterForm-Phone').name);
    console.log('City field name:', document.getElementById('RegisterForm-City').name);
  });
});

  } catch(e) { console.error(e); }
})();
})();
